export default "__VITE_ASSET__BbsXSqd2__"